module.exports = {
  partOptions: [
    {value: '1', text: 'Management Department'},
    {value: '2', text: 'Technology Research Center'},
    {value: '3', text: 'Customer Support Team'},
    {value: '4', text: 'Manufacturing Department'},
    {value: '5', text: 'Overseas Sales Department'}
  ],
  positionOptions: [
    {value: '1', text: 'Employee'},
    {value: '2', text: 'Deputy Manager'},
    {value: '3', text: 'Manager'},
    {value: '4', text: 'Team Leader'},
    {value: '5', text: 'Deputy Manager'},
    {value: '6', text: 'General Manager'},
    {value: '7', text: 'Director'}
  ],
  statusOptions: [{value: '1', text: 'Pending'}, {value: '2', text: 'Starting'}],
  categoryOptions: [
    {value: '1', text: 'Manual'},
    {value: '2', text: 'Promotional material'},
    {value: '3', text: 'Printed material'},
    {value: '4', text: 'Other'}
  ]
}